import React, {Component} from "react";
import {connect} from 'react-redux';
import {Collapse, Spin, Table} from "antd";
import {toLocaleString} from "../../../../UserService/Common/utils";

const Panel = Collapse.Panel;

class ModelDetail extends Component {

  render() {
    console.debug("ModelDetail:", this.props.selectId, this.props.selectType, this.props.modelMap[this.props.nodeId]);
    const modelInfo = this.props.modelMap[this.props.nodeId];

    let columns = [{
      title: "name",
      dataIndex: "name",
      key: "name",
      width: 100,
    }, {
      title: "value",
      dataIndex: "value",
      key: "value"
    }];

    let data = [{
      key: "1",
      name: "名称",
      value: modelInfo.name
    }, {
      key: "2",
      name: "类别",
      value: modelInfo.category ? modelInfo.category.name : "N/A"
    }, {
      key: "3",
      name: "创建时间",
      value: modelInfo.createdAt ? toLocaleString(modelInfo.createdAt, false) : "N/A"
    }, {
      key: "4",
      name: "文件路径",
      value: modelInfo.path ? modelInfo.path : "N/A",
    }, {
      key: "5",
      name: "文件大小",
      value: modelInfo.size ? modelInfo.size : "N/A"
    }, {
      key: "6",
      name: "所属项目",
      value: modelInfo.projectFile ? modelInfo.projectFile : "N/A"
    }, {
      key: "7",
      name: "用户",
      value: modelInfo.userId ? modelInfo.userId : "N/A"
    }, {
      key: "8",
      name: "是否系统",
      value: modelInfo.system ? "是" : "否"
    }];

    return (
      <Spin spinning={modelInfo === ""} size="large">
        <Collapse bordered={false} defaultActiveKey={['1']}>
          <Panel header="模型基础信息" key="1">
            <div style={{
              display: "flex",
              overflow: "scroll"
            }}>
              {/*<div>
                <div className="ds-detail-label">名称:</div>
                <div className="ds-detail-label">类别:</div>
                <div className="ds-detail-label">创建时间:</div>
                <div className="ds-detail-label">文件路径:</div>
                <div className="ds-detail-label">文件大小:</div>
                <div className="ds-detail-label">所属项目:</div>
                <div className="ds-detail-label">用户:</div>
                <div className="ds-detail-label">是否系统:</div>
              </div>
              <div style={{minWidth: 100}}>
                <div className="ds-detail-info">{modelInfo.name}</div>
                <div className="ds-detail-info">{modelInfo.category ? modelInfo.category.name : "N/A"}</div>
                <div className="ds-detail-info">{modelInfo.createdAt ? toLocaleString(modelInfo.createdAt, false) : "N/A"}</div>
                <div className="ds-detail-info">{modelInfo.path ? modelInfo.path : "N/A"}</div>
                <div className="ds-detail-info">{modelInfo.size ? modelInfo.size : "N/A"}</div>
                <div className="ds-detail-info">{modelInfo.projectFile ? modelInfo.projectFile : "N/A"}</div>
                <div className="ds-detail-info">{modelInfo.userId ? modelInfo.userId : "N/A"}</div>
                <div className="ds-detail-info">{modelInfo.system ? "是" : "否"}</div>
              </div>*/}
              <Table columns={columns} dataSource={data} showHeader={false} pagination={false}/>
            </div>
          </Panel>
          <Panel header="模型简介" key="2">
            <div style={{paddingLeft: 16}}>{modelInfo.description}</div>
          </Panel>
        </Collapse>
      </Spin>
    )
  }
}

export const mapStateToProps = (state) => {
  return {
    selectId: state.projectPanel.selectId,
    selectType: state.projectPanel.selectType,
    nodeId: state.projectPanel.nodeId
  }
};

export const mapDispatchToProps = (dispatch) => {
  return {
    dispatch
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ModelDetail);
